import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const AccessControlTranslations = wrapTranslationsSchema({
	name: 'AccessControlTranslations',
	title: 'Access Control Translations',
	sanityId: 'accessControl',
	fields: {
		returnToHomePage: 'Return to Home Page',
		noStoreTitle: 'This item is not associated with a store.',
		noStoreDescription:
			'Items in the Marketplace must be associated with a Store. If you are the content owner, please set the Store for this item. If you are not the owner, please report the following information',
		noStoreItemTitle: 'Item Title',
		noStoreItemSlug: 'Item Slug',
		noStoreItemLayout: 'Item Layout',
		noStoreStoreSlug: 'Store Slug',
		MsalTitle: 'Sign in to proceed',
		MsalDescription:
			'Please note that you must have an active Takeda SSO user account to access the Marketplace.',
		MsalSignInButton: 'Sign In',
		MsalSignOutButton: 'Sign Out',
		MsalSigningInMessage: 'Signing in...',
		accessDenied: 'Access Denied',
	},
});
